import React, { useEffect, useState } from 'react'
import Transparent from '../images/transparent.gif'
import axios from 'axios'
import { Link } from "react-router-dom";
import Loading from "../images/loading40.gif"
import moment from 'moment'
require('moment-timezone');


export default function Today(props) {


  const [cricket, setcricket] = useState([]);
  const [Soccer, setSoccer] = useState([]);
  const [Tennis, setTennis] = useState([])
  const [refresh, setrefresh] = useState(true);

  useEffect(() => {
    axios.get(
      `https://millionbet247.com/api/client/clientcricket`)

      .then(result => {
        result.data.map(item => {
          item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
          return item;
        })
        result.data.sort(function (a, b) {

          return moment(a.marketStartTime) - moment(b.marketStartTime);
        });
        var obj = [];

        result.data.map((item) => {

          var str = item.marketStartTime;
          var res = str.slice(11, 16);
          var today = moment();
          var thatDay = moment(item.marketStartTime);

          if (today.isSame(thatDay, 'day') && moment(item.marketStartTime).isAfter(moment(), 'seconds')) {
            obj.push(item);
          }

        });

        setcricket(obj);
      })
      .catch(error => console.log('error'));


    axios.get(
      `https://millionbet247.com/api/client/clienttennis`)

      .then(result => {
        result.data.map(item => {
          item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
          return item;
        })
        result.data.sort(function (a, b) {

          return moment(a.marketStartTime) - moment(b.marketStartTime);
        });

        var obj = [];

        result.data.map((item) => {
          var str = item.marketStartTime;
          var res = str.slice(11, 16);
          var today = moment();
          var thatDay = moment(item.marketStartTime);

          if (today.isSame(thatDay, 'day') && moment(item.marketStartTime).isAfter(moment(), 'seconds')) {
            obj.push(item);
          }

        });




        setTennis(obj);
      })
      .catch(error => console.log('error'));

    axios.get(
      `https://millionbet247.com/api/client/clientsoccer`)

      .then(result => {
        result.data.map(item => {
          item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
          return item;
        })

        result.data.sort(function (a, b) {

          return moment(a.marketStartTime) - moment(b.marketStartTime);
        });

        var obj = [];

        result.data.map((item) => {
          var str = item.marketStartTime;
          var res = str.slice(11, 16);
          var today = moment();
          var thatDay = moment(item.marketStartTime);

          if (today.isSame(thatDay, 'day') && moment(item.marketStartTime).isAfter(moment(), 'seconds')) {
            obj.push(item);
          }
        });



        setSoccer(obj);
        setrefresh(false);
      })


      .catch(error => console.log('error'));

  }, [])




  return (
    <div>

      {refresh &&

        <div className="loading-overlay" id="loading">
          <div className="loading-wrap" style={{ display: 'flex' }}>
            <div className="loading"><div /><div /></div><p>Loading...</p>
          </div></div>

      }


      {(cricket.length > 0 || Soccer.length > 0 || Tennis.length > 0) && refresh === false && <div id="sportListWrap" class="sport_list-wrap">

        {cricket.length > 0 && <div class="game-wrap ng-scope game-inplay">
          <h3 class="ng-binding">Cricket</h3>


          {cricket.map(function (item, id) {

            var showtoday = false;
            var showFancy = false;




            if (moment().diff(moment(item.marketStartTime), 'seconds') <= 0) {
              showtoday = true;
            }
            if (moment().diff(moment(item.marketStartTime), 'minutes') >= -30) {
              showFancy = true;
            }
            var str = item.marketStartTime;
            var res = str.slice(11, 16);



            var today = moment();
            var thatDay = moment(item.marketStartTime);

            return (
              <React.Fragment>

                {
                  today.isSame(thatDay, 'day') && moment(item.marketStartTime).isAfter(moment(), 'seconds')
                  &&
                  <dl class="game-list-col ng-scope" key={id}>

                    <dt id="openTime" class="time ng-binding">{res}</dt>

                    <dd id="eventDetail" class="ng-binding">
                      {/*<img class="fromto" src={Transparent} alt="fromto"/>T20 Blast*/}
                      <img class="fromto" src={Transparent} alt="images" />
                      <Link to={`/exchange/member/fullmarket/4/${item.eventId}/${item.marketId}`} id="vsNameClick" onClick={() => { props.changeState(true); }}>
                        <strong class="ng-binding">{item.eventName}</strong>
                      </Link>
                    </dd>
                  </dl>}
              </React.Fragment>
            )
          })}
        </div>}





        {Tennis.length > 0 && <div class="game-wrap ng-scope game-inplay">
          <h3 class="ng-binding">Tennis</h3>


          {Tennis.map(function (item, id) {
            var showtoday = false;

            if (moment().diff(moment(item.marketStartTime), 'seconds') <= 0) {
              showtoday = true;
            }

            var str = item.marketStartTime;
            var res = str.slice(11, 16);
            var today = moment();
            var thatDay = moment(item.marketStartTime);


            return (
              <React.Fragment>
                {today.isSame(thatDay, 'day') && moment(item.marketStartTime).isAfter(moment(), 'seconds') &&
                  <dl class="game-list-col ng-scope" key={id} >
                    <dt id="openTime" class="time ng-binding">{res}</dt>
                    <dd id="eventDetail" class="ng-binding">
                      {/*<img class="fromto" src={Transparent} alt="fromto"/>ATP Vienna 2020*/}
                      <img class="fromto" src={Transparent} alt="images" />
                      <Link to={`/exchange/member/fullmarket/2/${item.eventId}/${item.marketId}`} id="vsNameClick" onClick={() => { props.changeState(true); }}>
                        <strong class="ng-binding">{item.eventName}</strong>
                      </Link>
                    </dd>
                  </dl>}
              </React.Fragment>
            )
          })}

        </div>}





        {Soccer.length > 0 && <div class="game-wrap ng-scope game-inplay">
          <h3 class="ng-binding">Soccer</h3>



          {Soccer.map(function (item, id) {

            var showtoday = false;

            if (moment().diff(moment(item.marketStartTime), 'seconds') <= 0) {
              showtoday = true;
            }

            var str = item.marketStartTime;
            var res = str.slice(11, 16);
            var today = moment();
            var thatDay = moment(item.marketStartTime);

            return (
              <React.Fragment>
                {today.isSame(thatDay, 'day') && moment(item.marketStartTime).isAfter(moment(), 'seconds') &&
                  <dl class="game-list-col ng-scope" key={id} >
                    <dt id="openTime" class="time ng-binding">{res}</dt>
                    <dd id="eventDetail" class="ng-binding">
                      {/*<img class="fromto" src={Transparent} alt="fromto"/>ATP Vienna 2020*/}
                      <img class="fromto" src={Transparent} alt="images" />
                      <Link to={`/exchange/member/fullmarket/1/${item.eventId}/${item.marketId}`} id="vsNameClick" onClick={() => { props.changeState(true); }}>
                        <strong class="ng-binding">{item.eventName}</strong>
                      </Link>
                    </dd>
                  </dl>}
              </React.Fragment>
            )
          })}
        </div>}
      </div>}
      {(cricket.length === 0 && Soccer.length === 0 && Tennis.length === 0) && refresh === false && <div id="noDataDiv" class="no-data">
        <p>There are no events to be displayed.</p>
      </div>}


    </div>
  )
}
